import React, { Component } from 'react';
import '../../Asset/Css/util.css';
import '../../Asset/Css/main.css';
import 'reactjs-popup/dist/index.css';
import global from '../global'
import { Card, Row, Col, InputGroup, FormControl } from 'react-bootstrap';
import * as rdd from 'react-device-detect';

export class BrowserSupport extends Component {

    constructor(props) {
        super(props);
        this.state = {

            loading: false
        };
        this.initialState = this.state;
    }

    render() {

        return (
            <div className="container-login100 banner_area">

                <div className="container box_1620">
                    <div className="formDiv">
                        <div className="m-t-20 m-b-20">
                            <Row>
                                <Col md={12}>
                                    <h6 className="text-center text-black">Current Browser: {rdd.browserName} &  Current Version: {rdd.browserVersion}</h6><br />
                                    <h6 className="text-center text-black">The current browser is not supported. Try using any of the following Versions</h6><br />
                                    <div className="headersClientBS" style={{
                                        backgroundImage: `url(${process.env.PUBLIC_URL + "/Images/SupportedBrowsers.jpg"})`
                                    }}></div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </div>

        );
    }


}